var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTokenreward03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 45",
    style: {
      enableBackground: "new 0 0 45 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F9EDE5;}\r\n\t.st1{fill:#FFE8B9;}\r\n\t.st2{fill:#192731;}\r\n\t.st3{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,45H15C6.72,45,0,38.28,0,30V15C0,6.72,6.72,0,15,0h15c8.28,0,15,6.72,15,15v15C45,38.28,38.28,45,30,45z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.79,16.56h-7.77v-1.62c0-0.9-0.73-1.62-1.62-1.62h-4.57c-0.9,0-1.62,0.73-1.62,1.62v12.23 c0,1.66,1.34,3,3,3h12.59c1.66,0,3-1.34,3-3v-7.62C31.79,17.9,30.45,16.56,28.79,16.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28.79,31.38H16.21c-2.32,0-4.21-1.89-4.21-4.21V14.94c0-1.56,1.27-2.83,2.83-2.83h4.57 c1.56,0,2.83,1.27,2.83,2.83v0.41h6.56c2.32,0,4.21,1.89,4.21,4.21v7.62C33,29.49,31.11,31.38,28.79,31.38z M14.83,14.53 c-0.23,0-0.41,0.18-0.41,0.41v12.23c0,0.99,0.8,1.79,1.79,1.79h12.59c0.99,0,1.79-0.8,1.79-1.79v-7.62c0-0.99-0.8-1.79-1.79-1.79 h-7.77c-0.67,0-1.21-0.54-1.21-1.21v-1.62c0-0.23-0.18-0.41-0.41-0.41H14.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.56,22.96c-2.99,0-5.41,2.42-5.41,5.41h3.51C20.66,25.38,21.51,22.96,22.56,22.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.46,29.18h-5.12v-0.81c0-3.43,2.79-6.22,6.22-6.22v1.61c0.02,0,0.03,0,0.03,0 c-0.32,0.13-1.13,1.68-1.13,4.61V29.18z M18.03,27.57h1.84c0.06-1.18,0.25-2.34,0.59-3.29C19.2,24.92,18.28,26.13,18.03,27.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20.66,28.37h-3.51c0,2.99,2.42,5.41,5.41,5.41C21.51,33.79,20.66,31.36,20.66,28.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.56,34.59c-3.43,0-6.22-2.79-6.22-6.22v-0.81h5.12v0.81c0,2.93,0.81,4.48,1.13,4.61L22.56,34.59z  M18.03,29.18c0.25,1.44,1.18,2.64,2.43,3.29c-0.33-0.95-0.53-2.11-0.59-3.29H18.03z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.56,22.96c1.05,0,1.9,2.42,1.9,5.41h3.51C27.97,25.38,25.55,22.96,22.56,22.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28.78,29.18h-5.12v-0.81c0-2.93-0.81-4.48-1.13-4.61l0.03-1.61c3.43,0,6.22,2.79,6.22,6.22V29.18z  M25.25,27.57h1.84c-0.25-1.44-1.18-2.64-2.43-3.29C25,25.22,25.19,26.39,25.25,27.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.56,33.79c2.99,0,5.41-2.42,5.41-5.41h-3.51C24.47,31.36,23.61,33.79,22.56,33.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.56,34.59v-1.61c-0.02,0-0.03,0-0.03,0c0.32-0.13,1.13-1.68,1.13-4.61v-0.81h5.12v0.81 C28.78,31.8,25.99,34.59,22.56,34.59z M25.25,29.18c-0.06,1.18-0.25,2.34-0.59,3.29c1.26-0.65,2.18-1.85,2.43-3.29H25.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20.66,28.37h3.81c0-2.99-0.85-5.41-1.9-5.41C21.51,22.96,20.66,25.38,20.66,28.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.27,29.18h-5.42v-0.81c0-3,0.85-6.22,2.71-6.22c1.86,0,2.71,3.22,2.71,6.22V29.18z M21.49,27.57h2.15 c-0.13-2.32-0.77-3.6-1.08-3.79C22.26,23.97,21.61,25.24,21.49,27.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24.47,28.37h-3.81c0,2.99,0.85,5.41,1.9,5.41C23.61,33.79,24.47,31.36,24.47,28.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.56,34.59c-1.86,0-2.71-3.22-2.71-6.22v-0.81h5.42v0.81C25.27,31.37,24.42,34.59,22.56,34.59z  M21.49,29.18c0.13,2.32,0.77,3.6,1.08,3.79c0.31-0.19,0.95-1.47,1.08-3.79H21.49z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTokenreward03);
export default __webpack_public_path__ + "static/media/icon_tokenreward_03.6401e9647e6dcef9636ca1405babb21d.svg";
export { ForwardRef as ReactComponent };